import request from "@/utils/request"
//猜你喜欢
export function goodsGuessLike(data) {
  return request({
    url:'/tb/goodsGuessLike',
    method:'post',
    data
  })
}
export function goodsGuessLikeByNo(data) {
  return request({
    url:'/tb/goodsGuessLike',
    method:'post',
    data
  })
}
//分类
export function goodsCategory(data) {
  return request({
    url:'/tb/goodsCategory',
    method:'post',
    data
  })
}
//搜索
export function search(data) {
  return request({
    url:'/tb/search',
    method:'post',
    data
  })
}
//历史搜索
export function searchHistory(data) {
  return request({
    url:'/tb/searchHistory',
    method:'post',
    data
  })
}
//大家都在搜
export function searchPublic(data) {
  return request({
    url:'/tb/searchPublic',
    method:'post',
    data
  })
}
//商品详情
export function goodsDetail(data) {
  return request({
    url:'/tb/goodsDetail',
    method:'post',
    data
  })
}
//立即购买/领券；返回淘口令，提示已复制成功，请跳转到淘宝app领券购买
export function buyGoods(data) {
  return request({
    url:'/tb/buyGoods',
    method:'post',
    data
  })
}
//申请授权
export function scInviteCode(data) {
  return request({
    url:'/user/scInviteCode',
    method:'post',
    data
  })
}
//申请授权
export function clearHistory(data) {
  return request({
    url:'/tb/clearHistory',
    method:'post',
    data
  })
}
//联想词API：根据搜索关键词返回联想词，建议用户停止输入时进行接口请求。
export function suggestWord(data) {
  return request({
    url:'/tb/suggestWord',
    method:'post',
    data
  })
}
